module.exports = __webpack_public_path__ + "img/38.60f331ac.png";